<template>
  <a
    href="/kesfet"
    class="kesfet_promotion h-[53px] pl-3 py-2.5 bg-gradient-to-r from-[#9456e4] to-[#332393] rounded-xl flex justify-between items-center"
  >
    <div>
      <p class="text-white text-md sm:text-base font-normal leading-16 sm:leading-18">
        <span class="font-bold">Keşfet</span>
        ile ziyaret ettiğin
        <br v-if="isMobile" />
        tüm kategorileri tek akışta gör!
      </p>
    </div>
    <!-- ANIMATION -->
    <Swiper :settings="settings" :modules="[Autoplay]" class="h-full text-white w-[120px] !mr-0 mySwiper" @swiper="onSwiper">
      <SwiperSlide v-for="(item, index) in sliderItems" :key="index" class="u-center">
        <div
          :id="index"
          ref="slides"
          :class="[
            'flex items-center w-min h-[31px] gap-1 rounded-lg text-sm font-bold transition-all ml-auto',
            item.class,
            { '-translate-x-3': activeIndex === index },
          ]"
        >
          <span class="w-6 h-6"><OIcon :icon="`category/${item.icon}-white`" /></span>
          {{ item.text }}
        </div>
      </SwiperSlide>
    </Swiper>
  </a>
</template>
<script>
import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import { Autoplay } from 'swiper';
import Swiper from '~/modules/sliders/core/Swiper.vue';
import SwiperSlide from '~/modules/sliders/core/SwiperSlide.vue';
import { OButton, OImage, OIcon } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  components: { OIcon, OImage, Swiper, SwiperSlide, OButton },
  setup() {
    const { isMobile } = useDevice();

    const sliderItems = [
      {
        text: 'Test',
        icon: 'test',
        class: 'bg-[#F9BA00] pl-1.5 pr-2 py-2',
      },
      {
        text: 'Gündem',
        icon: 'gundem',
        class: 'bg-[#CD0000] pl-1 pr-2 py-2',
      },
      {
        text: 'Magazin',
        icon: 'magazin',
        class: 'bg-[#F72585] pl-1.5 pr-2 py-2',
      },
      {
        text: 'Video',
        icon: 'video',
        class: 'bg-[#0466C8] pl-1 pr-2 py-2',
      },
    ];

    const slides = ref();
    const settings = computed(() => ({
      direction: 'vertical',
      speed: 500,
      loop: true,
      autoplay: {
        delay: 2500,
      },
      allowTouchMove: false,
    }));

    const activeIndex = ref(0);
    const onSwiper = (swiper) => {
      slides.value[0]?.classList.add('-translate-x-3');

      swiper.on('slideChangeTransitionStart', function () {
        activeIndex.value = swiper.realIndex;
      });
    };

    return { sliderItems, Autoplay, settings, onSwiper, slides, isMobile, activeIndex };
  },
});
</script>
